<template>
    <iframe v-if="src" :src="src" style="height: 210px; width:100%" frameBorder="0" scrolling="no" />
</template>
<script>
export default {
    props: ['src', 'height'],
}
</script>